import React, { Component, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Switch } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';

import getRoutes from './routes';
import ABTestRedirect from './abtest/components/abtest-redirect';
import ThirdPartyTags from './third-party-tags';
import AdvancedScriptLoader from './third-party-tags/advanced-script-loader';
import IdleUser from './utility/components/idle-user';
import AboveTheFoldOnlyServerRender from './shared/components/above-the-fold-only-server-render';
import UserInputUpdater from './ui/components/user-input-type';
import SiteConfig from './page/site-config';
import Robots from './page/components/robots';
import FullPageLoader from './page/components/full-page-loader';
import StellarContext from './page/components/stellar-context';
import NewsLetter from './page/components/news-letter';
import AddToCartConfirm from './utility/components/add-to-cart-confirm';
import DispatchHydrationEvent from './third-party-tags/dispatch-hydration-event';
import GlobalMetrics from './metrics/components/global-metrics';
import AbTestConsentListener from './abtest/components/abtest-consent-listener';
import UtilityNavContainer from './utility/components/utility-nav-container';
import HeaderCart from './page/components/header-footer/header-cart';
import DigitLogin from './page/components/header-footer/digit-login';
import './App.less';
import './orion-reset-override.css';
import '@hpi-sox/hpstellar-global-styles/css/main.css';

/**
 * Note that this App entry point is not used for SSR.
 * So components added here will not be rendered until after hydration
 * See lib\web\client-server.js
 */
class App extends Component {
    render(props) {
        const { basename } = this.props;
        return (
            <StellarContext>
                <div className="App">
                    <Portal id="utilityNAV">
                        <UtilityNavContainer />
                    </Portal>
                    <Portal selector=".digitnav-cart" portalContainerClass="cart-portal">
                        <HeaderCart className="cart cart-button" variation="digit" />
                    </Portal>
                    <DigitLogin />
                    <FullPageLoader />
                    <Robots />
                    <UserInputUpdater />
                    <GlobalMetrics />
                    <AbTestConsentListener />
                    <DispatchHydrationEvent />
                    <Switch>
                        <ABTestRedirect>
                            {({ abTestRedirects }) => {
                                //put ab test redirect routes before normal routes
                                return renderRoutes(abTestRedirects.concat(getRoutes(basename)));
                            }}
                        </ABTestRedirect>
                    </Switch>
                    <AboveTheFoldOnlyServerRender showTimeout={6000} skip={true}>
                        {/*dont start tracking idle user until well after page load*/}
                        <IdleUser />
                    </AboveTheFoldOnlyServerRender>
                    <AboveTheFoldOnlyServerRender skip={true} robots={false}>
                        <ThirdPartyTags />
                    </AboveTheFoldOnlyServerRender>
                    <SiteConfig />
                    <AddToCartConfirm />
                    <AboveTheFoldOnlyServerRender showTimeout={1000} skip={true}>
                        <NewsLetter />
                    </AboveTheFoldOnlyServerRender>
                    <AdvancedScriptLoader />
                </div>
            </StellarContext>
        );
    }
}

const Portal = ({ children, id, selector, portalContainerClass }) => {
    const [portalContainer, setPortalContainer] = useState(null);
    useEffect(() => {
        const navContainer = selector ? document.querySelector(selector) : document.getElementById(id);
        if (navContainer) {
            setPortalContainer(navContainer);
            portalContainerClass && navContainer.classList.add(portalContainerClass);
        }
    }, []);

    return portalContainer ? ReactDOM.createPortal(children, portalContainer) : null;
};

/***
 * This is the SSR entry point for the UtilityNav
 * This content will get replaced by a portal on the client side
 */
export const UtilityNavSSR = () => {
    return (
        <StellarContext>
            <UtilityNavContainer />
        </StellarContext>
    );
};

export default App;
